/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken, getParams } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import ProRoomForm from './partials/ProRoomForm';
import './ProAddRoom.css';
import {
  fetchUser,
  listCompanies,
  createRoom,
} from '../actions';


class ProAddRoom extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {};

  constructor(props) {
    super(props);
    let params = getParams();
    if (params.location) {
      this.state.locationId = params.location;
    }
  }

  addRoom(e, values) {
    console.log('add room', values);
    this.props.createRoom(values)
      .then(resp => {
        console.log('create room resp', resp);
        if (resp.error) return;
        navTo('/pro/rooms/' + resp.obj.id);
      });
  }

  render() {
    return (
      <Wrapper className="ProAddRoom" padded pro>
        <Helmet>
          Add Room - EscapeSpy
        </Helmet>
        <div className="pro-header">Add Room</div>

        <div className="form-wrapper">
          <ProRoomForm
            errors={this.props.errors.room}
            values={{ locationId: this.state.locationId }}
            onSubmit={(e, values) => this.addRoom(e, values)}
            buttonText="Add Room"
          />
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listCompanies,
    createRoom,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProAddRoom);



/** WEBPACK FOOTER **
 ** ./src/components/ProAddRoom.js
 **/